"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getHeadline(resultCode) {
    switch (resultCode) {
        case 'YYYN':
        case 'YYYY':
        case 'YYXX':
        case 'YYNN':
        case 'YYNY':
            return 'goalAchievedHeader';
        case 'NNXX':
        case 'NNYY':
        case 'NNNY':
        case 'NNNN':
            return 'goalMissedHeader';
        case 'NYXX':
        case 'NYNN':
        case 'NYNY':
        case 'NYYN':
        case 'NYYY':
            return 'header--niceJob';
        case 'NNYN':
            return 'bonusAchievedHeader';
        default:
            return '';
    }
}
exports.getHeadline = getHeadline;
function getSubHeadline(resultCode) {
    switch (resultCode) {
        case 'NNNN':
        case 'NNNY':
            return 'goalBonusMissedSubhead';
        case 'YYYN':
        case 'YYYY':
        case 'YYXX':
        case 'YYNN':
        case 'YYNY':
        case 'NYXX':
        case 'NYNN':
        case 'NYNY':
        case 'NYYN':
        case 'NYYY':
        case 'NNYN':
            return 'goalAchievedSubhead';
        case 'NNYY':
        case 'NNXX':
            return 'goalMissedSubhead';
        default:
            return '';
    }
}
exports.getSubHeadline = getSubHeadline;
function getMessage(resultCode) {
    switch (resultCode) {
        case 'YYYN':
        case 'YYYY':
            return 'message--goalAchieved-Y--earnedBaseEarnings-Y--achievedBonus-y';
        case 'YYNN':
        case 'YYNY':
            return 'message--goalAchieved-Y--earnedBaseEarnings-Y--achievedBonus-N';
        case 'YYXX':
            return 'message--goalAchieved-Y--earnedBaseEarnings-Y';
        case 'NNXX':
            return 'message--goalAchieved-N--earnedBaseEarnings-N';
        case 'NNNN':
        case 'NNNY':
            return 'message--goalAchieved-N--earnedBaseEarnings-N--achievedBonus-N';
        case 'NYXX':
            return 'message--goalAchieved-N--earnedBaseEarnings-Y';
        case 'NYNN':
        case 'NYNY':
            return 'message--goalAchieved-N--earnedBaseEarnings-Y--achievedBonus-N';
        case 'NYYN':
            return 'message--goalAchieved-N--earnedBaseEarnings-Y--achievedBonusNotCoupled-Y';
        case 'NYYY':
            return 'message--goalAchieved-N--earnedBaseEarnings-Y--achievedBonusCoupled-N';
        case 'NNYN':
            return 'message--goalAchieved-N--earnedBaseEarnings-N--achievedBonusNotCoupled-N';
        case 'NNYY':
            return 'message--goalAchieved-N--earnedBaseEarnings-N--achievedBonusCoupled-N';
        default:
            return '';
    }
}
exports.getMessage = getMessage;
//# sourceMappingURL=challengepoint-codes.js.map